<div class="container animated-fade-in">
  <div class="row mb-4">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h2><i class="fa fa-map-marker"></i> RSA Provider Management</h2>
        </div>
        <div class="card-body">
          <form [formGroup]="providerForm" (ngSubmit)="submit()" class="provider-form">
            <!-- Provider Details Section -->
            <div class="section-heading">
              <i class="fa fa-info-circle"></i> Provider Details
            </div>
            
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="providerName">
                    <i class="fa fa-building"></i> Provider Name
                  </label>
                  <input 
                    id="providerName"
                    type="text" 
                    class="form-control" 
                    formControlName="providerName" 
                    [ngClass]="{'is-invalid': providerForm.get('providerName').invalid && providerForm.get('providerName').touched}" 
                    required />
                  <div class="invalid-feedback" *ngIf="providerForm.get('providerName').invalid && providerForm.get('providerName').touched">
                    Provider name is required
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="providerAddress">
                    <i class="fa fa-address-card"></i> Provider Address
                  </label>
                  <input 
                    id="providerAddress"
                    type="text" 
                    class="form-control" 
                    formControlName="providerAddress" 
                    [ngClass]="{'is-invalid': providerForm.get('providerAddress').invalid && providerForm.get('providerAddress').touched}" 
                    required />
                  <div class="invalid-feedback" *ngIf="providerForm.get('providerAddress').invalid && providerForm.get('providerAddress').touched">
                    Provider address is required
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Location Section -->
            <div class="section-heading">
              <i class="fa fa-map"></i> Location Details
            </div>
            
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="state" class="state-label">
                    <i class="fa fa-globe"></i> State
                  </label>
                  <select 
                    id="state"
                    class="form-control state-select" 
                    formControlName="state" 
                    [ngClass]="{'is-invalid': providerForm.get('state').invalid && providerForm.get('state').touched}" 
                    (change)="onStateChange(providerForm.value.state)" 
                    required>
                    <option value="">-- Select State --</option>
                    <option *ngFor="let state of stateList" [value]="state">{{state}}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="providerForm.get('state').invalid && providerForm.get('state').touched">
                    State is required
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="city">
                    <i class="fa fa-building-o"></i> City
                  </label>
                  <input 
                    id="city"
                    type="text" 
                    class="form-control" 
                    formControlName="city" 
                    [ngClass]="{'is-invalid': providerForm.get('city').invalid && providerForm.get('city').touched}"
                    (input)="onCityInput(providerForm.value.city)" 
                    (blur)="onCitySelect(providerForm.value.city)" 
                    autocomplete="off" 
                    required />
                  <ul class="autocomplete-list" *ngIf="filteredCities.length && providerForm.value.city">
                    <li *ngFor="let city of filteredCities" (mousedown)="onCitySelect(city)">{{city}}</li>
                  </ul>
                  <div class="invalid-feedback" *ngIf="providerForm.get('city').invalid && providerForm.get('city').touched">
                    City is required
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Contact and Map Section -->
            <div class="section-heading">
              <i class="fa fa-phone"></i> Contact Information
            </div>
            
            <div class="row mb-4">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="contactNumber">
                    <i class="fa fa-phone"></i> Contact Number
                  </label>
                  <input 
                    id="contactNumber"
                    type="text" 
                    class="form-control" 
                    formControlName="contactNumber" 
                    [ngClass]="{'is-invalid': providerForm.get('contactNumber').invalid && providerForm.get('contactNumber').touched}" 
                    placeholder="10-digit number" 
                    required />
                  <div class="invalid-feedback" *ngIf="providerForm.get('contactNumber').invalid && providerForm.get('contactNumber').touched">
                    Valid 10-digit contact number is required
                  </div>
                </div>
              </div>
            </div>
            
            <div class="section-heading">
              <i class="fa fa-map-marker"></i> Map Location 
              <small class="text-muted">(Click on the map to set the provider's location)</small>
            </div>
            
            <div class="row mb-4">
              <div class="col-md-12">
                <div class="map-container">
                  <google-map
                    height="350px"
                    width="100%"
                    [center]="{lat: lat, lng: lng}"
                    [zoom]="12"
                    (mapClick)="onMapClick($event)">
                    <map-marker *ngIf="markerSet" [position]="{lat: lat, lng: lng}"></map-marker>
                  </google-map>
                </div>
                <div class="coordinate-display" *ngIf="providerForm.value.latitude && providerForm.value.longitude">
                  <i class="fa fa-crosshairs"></i> Coordinates: 
                  <span class="badge bg-info">
                    Lat: {{providerForm.value.latitude | number:'1.6-6'}}
                  </span>
                  <span class="badge bg-info">
                    Lng: {{providerForm.value.longitude | number:'1.6-6'}}
                  </span>
                </div>
              </div>
            </div>
            
            <!-- Form Actions -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-actions">
                  <button type="submit" class="btn btn-primary" [disabled]="submitting || providerForm.invalid">
                    <i class="fa fa-plus-circle"></i> Add RSA Provider
                  </button>
                  <button type="button" class="btn btn-secondary ml-2" (click)="providerForm.reset()">
                    <i class="fa fa-refresh"></i> Reset
                  </button>
                </div>
              </div>
            </div>
          </form>
          
          <!-- Success/Error Message -->
          <div class="alert" [ngClass]="{'alert-success': message && !message.includes('Error'), 'alert-danger': message && message.includes('Error')}" *ngIf="message">
            <i class="fa" [ngClass]="{'fa-check-circle': !message.includes('Error'), 'fa-exclamation-triangle': message.includes('Error')}"></i> {{message}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
